export const REBATE_BILL_EXTENT = {
    bills: true,
    orderItems: true,
    products: true,
    serviceOrders: true,
    rebates: true,
};

export const fieldNames = {
    REBATE_REASON: 'rebateReason',
    PRESELECTED_REBATE_REASON: 'preselectedRebateReason',
} as const;
